export type ActionableTabState = {
  duringTrip: boolean
  photoDue: boolean
  challengeDue: boolean
  pollDue: boolean
}

export function selectActionableTabs(state: ActionableTabState): ReadonlySet<string> {
  if (!state.duringTrip) return new Set()
  const tabs = new Set<string>()
  if (state.photoDue) tabs.add('/souvenirs')
  if (state.challengeDue || state.pollDue) tabs.add('/groupe')
  return tabs
}
